import { useEffect } from 'react';
import { lerp } from '@colonist/utils';
import { AudioManager, AudioType } from '@colonist/audio';
const SECONDS_LEFT_BEFORE_TICKING_SOUND = 5;
export function useTimerLowTime(timeLeftInSeconds, isSoundEnabled) {
    const isLowTime = timeLeftInSeconds <= SECONDS_LEFT_BEFORE_TICKING_SOUND;
    useEffect(()=>{
        if (!isSoundEnabled || !isLowTime) return;
        const isFirstReminder = timeLeftInSeconds == SECONDS_LEFT_BEFORE_TICKING_SOUND;
        if (isFirstReminder) AudioManager.play(AudioType.FirstReminder, 0.6, 1.0);
        const progress = (SECONDS_LEFT_BEFORE_TICKING_SOUND - timeLeftInSeconds) / SECONDS_LEFT_BEFORE_TICKING_SOUND;
        const minimumVolume = 1.0;
        const maximumVolume = 1.2;
        const volume = lerp(minimumVolume, maximumVolume, progress);
        const minimumPitch = 1.0;
        const maximumPitch = 1.5;
        const pitch = lerp(minimumPitch, maximumPitch, progress);
        AudioManager.play(AudioType.ClockTick, volume, pitch);
    }, [
        timeLeftInSeconds,
        isSoundEnabled,
        isLowTime
    ]);
    return isLowTime;
}
